module.exports = __webpack_public_path__ + "img/grgwjkxt2.35358ecc.jpg";